export default __webpack_public_path__ + "static/media/welcome.ad849e96.png";